// Errors thrown entirely inside a third-party tracking script are not ours to
// fix. HubSpot's ad pixel (js.hsadspixel.net/pixels.js) JSON.parses a plaintext
// "Restricted" response inside its own XHR handler, and Honeybadger's wrapped
// callback (___hb) reports it: HB fault 135159150 (st#7030), same shape as
// st#4259. Every backtrace was:
//   <anonymous> JSON.parse
//   https://js.hsadspixel.net/pixels.js:1 XMLHttpRequest.<anonymous>
//   .../packs/js/2366-*.js n.___hb
//
// beforeNotify in packs/app.js drops a notice when its top in-app frame is
// served from one of these hosts. Only the TOP real frame counts, so an error
// that starts in our own pack and merely passes through a tracker still
// reports.
//
// Hosts are the ones the layouts actually load (js.hs-scripts.com and
// googletagmanager.com in application/devise layouts) plus the HubSpot ad
// pixel host seen in the fault. Matching is on the parsed hostname, never a
// substring, so a URL that merely contains a tracker name does not match.

export const THIRD_PARTY_TRACKER_HOSTS = [
  "js.hsadspixel.net",
  "js.hs-scripts.com",
  "www.googletagmanager.com",
];

const hostOf = (file) => {
  if (typeof file !== "string" || file.length === 0) return null;
  try {
    // Protocol-relative URLs ("//js.hs-scripts.com/...") need a base.
    return new URL(file, "https://placeholder.invalid").hostname.toLowerCase();
  } catch {
    return null;
  }
};

const isSkippableFrame = (frame) => {
  const file = frame?.file;
  if (typeof file !== "string" || file.length === 0) return true;
  if (file === "<anonymous>") return true;
  // Honeybadger's own wrapper around event callbacks.
  return /___hb\b/.test(String(frame?.method || ""));
};

export const isThirdPartyTrackerNoise = (notice) => {
  const backtrace = notice?.backtrace;
  if (!Array.isArray(backtrace) || backtrace.length === 0) return false;

  const top = backtrace.find((frame) => !isSkippableFrame(frame));
  if (!top) return false;

  const host = hostOf(top.file);
  return host !== null && THIRD_PARTY_TRACKER_HOSTS.includes(host);
};
